module.exports = __webpack_public_path__ + "static/media/guiaContribuicao.c91a8cc0.md";